import { Navigate } from "react-router-dom";
import { useState } from "react";
import { HOME_ROUTE, TUTOR_FINANCE_ROUTE } from "../../app/router/routes";
import { useAppSelector } from "../../app/store/store";
import { TutorPenaltyBonus } from "../../widgets/tutorPenaltyBonus";
import { LayoutPages } from "../layoutPages";
import { TutorFinance } from "../../widgets/tutorFinance";
import { ReceiptPending } from "../../widgets/receiptPending";
import { TutorAccruals } from "../../widgets/tutorAccruals";
import { MyPayouts } from "../../widgets/myPayouts";
import { OpenContainer } from "../../features/openContainer";
import classes from './tutorFinance.module.scss'
import { FEATURES, FEATURE_SECTIONS, hasFeature } from "../../entities/my";

export default function TutorFinancePage() {

    const {my} = useAppSelector(s => s.myReducer)
    const [receiptRefreshKey, setReceiptRefreshKey] = useState(0)

    const tutorId = my.id
    const canTutorFinance = hasFeature(my, FEATURES.TUTORS.FINANCE_READ, tutorId)
    const showTutorAccruals = my.role === 'tutor' && hasFeature(my, FEATURES.TUTORS.PAYOUTS_READ, tutorId)

    if(!hasFeature(my, FEATURE_SECTIONS.FINANCE) || !canTutorFinance || !tutorId){
        return <Navigate to={HOME_ROUTE.path} />
    }

    return (
        <LayoutPages title={TUTOR_FINANCE_ROUTE.name}>
            <section className={classes.container}>
                {showTutorAccruals && <>
                    <section className={classes.receiptStatus}>
                        <ReceiptPending inline refreshKey={receiptRefreshKey} />
                    </section>
                    <section className={classes.finance + ' ' + classes.myPayouts}>
                        <MyPayouts
                            key={tutorId}
                            refreshKey={receiptRefreshKey}
                            onReceiptSaved={() => setReceiptRefreshKey(prev => prev + 1)}
                        />
                    </section>
                </>}
                <section className={classes.finance + ' ' + classes.calendar}>
                    <OpenContainer title="Финансы" allowOverflow>
                        <section className={classes.dropdownContent}>
                            <TutorFinance id={tutorId} />
                        </section>
                    </OpenContainer>
                </section>
                {
                    showTutorAccruals &&
                    <>
                        <section className={classes.finance + ' ' + classes.accruals}>
                            <OpenContainer title="Выплаты" allowOverflow>
                                <section className={classes.dropdownContent}>
                                    <TutorAccruals hideTitle onTrigger={() => setReceiptRefreshKey(prev => prev + 1)} />
                                </section>
                            </OpenContainer>
                        </section>
                    </>
                }
                {
                    hasFeature(my, FEATURES.TUTORS.PENALTIES_BONUSES_SELF_READ, tutorId)
                        &&
                    <section className={classes.penaltyBonus}>
                        <TutorPenaltyBonus 
                            tutorId={null} 
                            collapsible
                        />
                    </section>
                }
            </section>
        </LayoutPages>
    )
}
